/*
 * Copyright (c) 2019-2021 LogMeIn
 * All Rights Reserved Worldwide.
 *
 * THIS PROGRAM IS CONFIDENTIAL AND PROPRIETARY TO LOGMEIN
 * AND CONSTITUTES A VALUABLE TRADE SECRET.
 */

import React from 'react';
import { IntlProvider } from 'react-intl';
import { DefaultThemeProvider, Flex } from '@getgo/chameleon-chakra-ui';
import { GoToMeetingTheme } from '../../themes/GoToMeetingTheme';
import { Footer } from '../Footer/Footer';
import { SessionContext } from '../../context/SessionContext';
import { Header } from '../Header/Header';
import { Main } from '../MainContent/MainContent';
import { PageProps } from './Layout';

export const LayoutGoToMeeting: React.FC = ({ children }) => (
  <DefaultThemeProvider theme={GoToMeetingTheme}>
    <Flex
      id='scrollcushion'
      flexDirection='column'
      justifyContent='space-between'
      minWidth='min-content'
    >
      <Header />
      <Main>{children}</Main>
      <Footer />
    </Flex>
  </DefaultThemeProvider>
);

export const GoToMeetingPages: React.FC<PageProps> = ({
  locale,
  translationsForLocale,
  sessionParams,
  children,
}) => (
  <SessionContext.Provider value={sessionParams}>
    <IntlProvider
      locale={locale}
      messages={translationsForLocale}
      textComponent={React.Fragment}
    >
      <LayoutGoToMeeting>{children}</LayoutGoToMeeting>
    </IntlProvider>
  </SessionContext.Provider>
);
